import {Module} from 'vuex';

/**
 * 竣工评论数据模块
 * @type {Module}
 */
export const particulars = {
    namespaced: true,
    state: {
        // 用户合同列表
        arrUserContractList:[
            // {
            //     name:'徐女士', // 用户名
            //     score: 80, // 评分
            //     isVip: true, // 是否vip
            //     address:'南京市栖霞区尧新大道336号', // 地址
            //     startTime:'2021-5-21', // 开工时间
            //     endTime:'2021-9-21', // 完工时间
            //     contractNo:'XXXXXXXXXXXXX', // 合同编号
            //     imageUrl:require('@/assets/images/service/text-001.png'), // 头像地址
            //     id: 1
            // },
            // {
            //     name:'徐女士', // 用户名
            //     score: 60, // 评分
            //     isVip: true, // 是否vip
            //     address:'南京市栖霞区尧新大道336号', // 地址
            //     startTime:'2021-5-21', // 开工时间
            //     endTime:'2021-9-21', // 完工时间
            //     contractNo:'XXXXXXXXXXXXX', // 合同编号
            //     imageUrl:require('@/assets/images/service/text-001.png'), // 头像地址
            //     id: 2
            // },
            // {
            //     name:'徐女士', // 用户名
            //     score: 50, // 评分
            //     isVip: false, // 是否vip
            //     address:'南京市栖霞区尧新大道336号', // 地址
            //     startTime:'2021-5-21', // 开工时间
            //     endTime:'2021-9-21', // 完工时间
            //     contractNo:'XXXXXXXXXXXXX', // 合同编号
            //     imageUrl:require('@/assets/images/service/text-001.png'), // 头像地址
            //     id: 3
            // },
            // {
            //     name:'徐女士', // 用户名
            //     score: 60, // 评分
            //     isVip: false, // 是否vip
            //     address:'南京市栖霞区尧新大道336号', // 地址
            //     startTime:'2021-5-21', // 开工时间
            //     endTime:'2021-9-21', // 完工时间
            //     contractNo:'XXXXXXXXXXXXX', // 合同编号
            //     imageUrl:require('@/assets/images/service/text-001.png'), // 头像地址
            //     id: 4
            // }
        ]
    },
    mutations: {},
    actions: {},
    getters: {},
}

